import { CustomAssetForm } from './CustomAssetForm';
import { CreateStrategyAssetCategoryForm } from './CreateStrategyAssetCategoryForm';

import { AddCustomAssetOrCreateAssetCategoryProps } from './types';
import { CreateStrategyAssetStepEnum } from '../../../constants/enums';

export const AddCustomAssetOrCreateStrategyAssetCategory = ({
  reportingCurrency,
  step,
  formik,
  strategyAssetCategories,
  action,
}: AddCustomAssetOrCreateAssetCategoryProps) => (
  <div className="flex overflow-y-scroll h-full">
    <form className="flex w-full" autoComplete={'off'}>
      <div className="flex flex-col w-full mt-5">
        {step === CreateStrategyAssetStepEnum.CUSTOM_CATEGORY ? (
          <CreateStrategyAssetCategoryForm
            formik={formik}
            strategyAssetCategories={strategyAssetCategories}
          />
        ) : (
          <CustomAssetForm
            formik={formik}
            reportingCurrency={reportingCurrency}
            action={action}
          />
        )}
      </div>
    </form>
  </div>
);
